import gql from "graphql-tag"
import { SchoolFragmentDoc } from "@pathwright/graphql-client/src/generated"

export default gql`
  query UserSchoolResourceLicensesQuery(
    $id: Int!
    $cursor: String
    $role: MembershipRole
    $license_offering_id: Int
  ) {
    user(id: $id) {
      id
      memberships(first: 50, after: $cursor, role: $role, global: true) {
        total
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            role
            school {
              ...School
              resource_license(license_offering_id: $license_offering_id) {
                id
              }
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
`
